module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Lunch_Friday.00c7d82f.jpg";